export default function (source: any[] | undefined, id: string = "", selector?: string) {
	if (undefined === source) return "";
	// @todo find a good typescript way to define an array of objects containing an id which is a string
	const details = source.find((s: any) => id === s.id);
	if (undefined !== details) {
		return undefined === selector ? details : details[selector];
	}
	return "";
}
